<!--=================================
 preloader -->
<div id="pre-loader" *ngIf="commondata.loader.value">
    <img src="assets/images/pre-loader/loader-01.svg" alt="">
</div>
<div class="page-wrapper">
    <div class="authentication-box">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 col-md-6" *ngIf="message != ''">
                    <div class="card text-center">
                        <div class="svg-icon mb-0">
                            <img alt="" src="assets/images/{{logo}}">
                        </div>
                        <div class="card-body">
                            <h5><em>"{{message}}"</em></h5>
                            <div class="form-button">
                                <button class="btn btn-primary" [routerLink]="'/auth/login'">Ok</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-5 p-0 card-left" *ngIf="message == ''">
                    <div class="card bg-primary mb-0 p-2">
                        <div class="svg-icon1 d-flex justify-content-center" style="min-height: 12rem">
                            <img alt="" class="my-2" src="assets/images/{{this.logo}}" style="height: auto; object-fit: contain">
                        </div>
                        <div *ngIf="functionCalled" class="single-item">
                            <owl-carousel-o [options]="owlcarouselOptions">
                                <ng-container *ngFor="let data of owlcarousel">
                                    <ng-template carouselSlide class="item">
                                        <div>
                                            <h3>{{data.title}}</h3>
                                        </div>
                                    </ng-template>
                                </ng-container>
                            </owl-carousel-o>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-7 p-0 card-right" *ngIf="message == ''">
                    <div class="card tab2-card p-4">
                        <div class="card-body">
                            <h4 class="login-text">Forgot Password</h4>

                            <div class="tab-pane fade active show mt-4">
                                <form [formGroup]="loginForm"
                                      class="form-horizontal auth-form" novalidate="" *ngIf="!forgotList">
                                    <div class="form-group">
                                        <input autofocus formControlName="userName" name="login[username]" type="text"
                                               class="form-control" placeholder="Please Enter Email Id" pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,4}$"
                                               id="exampleInputEmail1" autocomplete="off">
                                        <em class="error" *ngIf="loginForm.get('userName').hasError('required') && (loginForm.get('userName').dirty || loginForm.get('userName').touched)">Email is required</em>
                                        <em class="error" *ngIf="loginForm.get('userName').hasError('pattern')">Invalid Email-Id</em>
                                    </div>

                                    <div class="form-terms" *ngIf="type != 'grader' && type != 'corporate'">
                                        <div class="custom-control custom-checkbox mr-sm-2">
                                            <input type="checkbox" class="custom-control-input"
                                                   id="customControlAutosizing">
                                            <a [routerLink]="'/auth/login'"
                                               class="btn btn-default forgot-pass italic_text">Back to Login</a>
                                        </div>
                                    </div>
                                    <div class="form-button">
                                        <button class="btn btn-primary w-100" (click)="change()">Submit<i class="ml-2 fa fa-long-arrow-right fa-1x" aria-hidden="true"></i></button>
                                    </div>
                                </form>
                                <form autocomplete="off"
                                      [formGroup]="forgotForm"
                                      class="form-horizontal auth-form" novalidate="" *ngIf="forgotList">
                                    <div class="form-group">
                                        <input autocomplete="new-password" required="" formControlName="password"  type="password"
                                               class="form-control" placeholder="Password" maxlength="20">
                                        <em class="error" *ngIf="forgotForm.get('password').hasError('required') && (forgotForm.get('password').dirty || forgotForm.get('password').touched)">Password is required</em>
                                        <em *ngIf="forgotForm.get('password').hasError('minlength')" class="error help-block">Minimum 5 characters required</em>
                                    </div>

                                    <div class="form-group">
                                        <input autocomplete="new-password" required="" formControlName="confirmpassword"  type="password"
                                               class="form-control" placeholder="Confirm Password" maxlength="20">
                                        <div *ngIf="forgotForm.controls['confirmpassword'].touched && !forgotForm.controls['confirmpassword'].valid">
                                            <em class="error help-block" *ngIf="forgotForm.controls['confirmpassword'].hasError('required') " >
                                                Enter Confirm Password
                                            </em>

                                        </div>
                                        <div *ngIf="checkPasswords()">
                                            <em class="error help-block">
                                                Enter same password as above
                                            </em>
                                        </div>
                                    </div>
                                    <div class="form-button">
                                        <button class="btn btn-primary w-100" (click)="update()">Submit<i class="ml-2 fa fa-long-arrow-right fa-1x" aria-hidden="true"></i></button>
                                    </div>

                                </form>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
